import Icon from "../../design_system/core/components/icon"
import React from "react"

export default (props, railsContext) => {
  return () => <Icon {...props} />
}
